import { render } from "./InquiryAnswerPage.vue?vue&type=template&id=204ee082&lang=true"
import script from "./InquiryAnswerPage.vue?vue&type=script&lang=js"
export * from "./InquiryAnswerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__